import React from 'react';
import { Box, CircularProgress } from '@mui/material';

/**
 * LoadingOverlay - קומפוננטת טעינה עם overlay
 * מציגה עיגול טעינה כחול על רקע שקוף
 * 
 * @param {boolean} open - האם להציג את ה-overlay
 * @param {number} size - גודל העיגול (ברירת מחדל: 60)
 * @param {string} color - צבע העיגול (ברירת מחדל: #1e3a5f)
 * @param {boolean} fullScreen - האם להציג מסך מלא או רק בתוך הקונטיינר (ברירת מחדל: true)
 */
const LoadingOverlay = ({ open = false, size = 60, color = '#1e3a5f', fullScreen = true }) => {
    if (!open) return null;

    return (
        <Box
            sx={{
                position: fullScreen ? 'fixed' : 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                bgcolor: 'transparent',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 9999
            }}
        >
            <CircularProgress size={size} sx={{ color }} />
        </Box>
    );
};

export default LoadingOverlay;
